export default function arrayService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};
    viewField.state = viewField.state || [];
    viewField.metadata.max = viewField.metadata.max || viewField.max || 99999;

    const modelOut = engineApi.utils.getLastItem(viewField.model);

    const element = engineApi.register.setCommonAttributes('fb-grid', viewField, engineApi, { setDisabled: true }).addAttributes({
      'view-property-key': engineApi.dispatcher.set(viewField, `${viewField.name}_viewProperty`),
      'engine-api-key': engineApi.dispatcher.set(engineApi, `${viewField.name}_engineApi`),
      current: modelOut,
      sortable: typeof viewField.metadata.sortable !== 'undefined' ? viewField.metadata.sortable : true,
    });

    if (viewField.metadata.toolbar) {
      element.addAttribute('toolbar', JSON.stringify(viewField.metadata.toolbar), true, "'");
    }

    if (viewField.title) {
      element.addAttribute('label', viewField.title || '');
    }

    if (engineApi.options.isReadOnly) {
      element.addAttribute('readonly', '');
    }

    return element;
  };
}
